import Counter from "../../../common/counter";
import Button from "../../../common/button";
import { BannerV1Wrapper, BannerContent } from "./Banner.style";
import homeImageBG from "../../../assets/images/nft/home_img.png";
import { useNFTMinted } from "../../../hooks/useNFTMinted";
import { NFT_PRICE } from "../../../config";
import MintNowModal from "../../../common/modal/mintNowModal/MintNowModal";

const Banner = ({...props}) => {
  const { data: remaining } = useNFTMinted();

  return (
    <BannerV1Wrapper id="home">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="hermes_v1_baner_left">
              <div className="hermes_v1_baner_left_img_sect">
                <BannerContent {...props}>
                  <img src={homeImageBG} alt="" />
                </BannerContent>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="hermes_v1_baner_right">
              <h2>
                HERMES BASE <br /> NFT collections
              </h2>
              <h3>
                <span className="count">
                  <Counter end={remaining} duration={remaining} />
                </span>{" "}
                / 1000 Minted
              </h3>
              <div className="banner_buttons">
                <MintNowModal />
                <Button lg variant="outline">
                  Wishlist now
                </Button>
              </div>
              <div className="coin-info">
                <span>PRICE {NFT_PRICE} ETH + gas</span>
                <span>
                  MINT IS LIVE UNTIL{" "}
                  <span className="highlighted">11 DEC 2023 04:00H</span>
                </span>
                <span>Status: ONGOING</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BannerV1Wrapper>
  );
};

export default Banner;
